import {Component, Input} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {VersionInfoModel} from '@core/models';


@Component({
  standalone: true,
  selector: 'app-update-dialog',
  templateUrl: './app-update-dialog.component.html',
  styleUrls: ['./app-update-dialog.component.scss'],
  imports: [
    IonicModule
]
})
export class AppUpdateDialogComponent {

  @Input() updateInfo: VersionInfoModel;
  constructor() {
  }

  updateApp() {
    window.open(this.updateInfo.updateLink, '_system', 'location=yes');
  }
}
